import React, { useCallback, useContext, useEffect, useState } from 'react';
import { addNotificationsfromPaginateToLocalStorage, addNotificationToLocalStorage, getNotificationsFromLocalStorage, loadNotificationsByUser, markNotificationAsRead, renderNotification } from './helper';
import { DisclosureBell, MenuBell } from '../buttons/navigation/MenuBell';
import { useWebSocketClient } from '../../context/websocketClient';
import notificationSound from '../../public/sounds/service-bell-sound.wav';
import './Notifications.css';
import { NotificationsService } from '../../services/notifications/notifications.service';
import { notificationConfigs } from '../../utils/notificationConfigs';
import { NotificationsContext } from '../../context/Disclosures/notifications/notificationsContext';
import { RewardsViewContext } from '../../context/Disclosures/rewards/rewardsContext';

export const Notifications = ({ device }) => {
  const { updateRewardsView, rewardsViewData } = useContext(RewardsViewContext);
  const { notificationsData, updateNotificationsData } = useContext(NotificationsContext);
  const [notifications, setNotifications] = useState([]);
  const [hasUpdatedNotifications, setHasUpdatedNotifications] = useState(false);
  const [iconEffect, setIconEffect] = useState(false);
  const [unreadNotifications, setUnreadNotifications] = useState(false);
  const [page, setPage] = useState(2);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const handler = {
    notification: (data) => {
      addNotificationToLocalStorage(data);
      handleGetNotifications();
      setHasUpdatedNotifications(true);
      const audio = new Audio(notificationSound);
      audio.play();
      setTimeout(() => setIconEffect(true), 2000);
      setTimeout(() => setIconEffect(false), 4000);
    },
  };

  useWebSocketClient({ userId: localStorage.getItem('doc'), handler });

  const handleSetUnreadNotifications = (_notifications = []) => {
    const _unreadNotifications = (noti) => noti.read === false;
    let unreadNotifications = _notifications.some(_unreadNotifications);
    updateNotificationsData({ unreadNotifications: unreadNotifications });
    setUnreadNotifications(unreadNotifications);
  };

  const handleOpenDisclosureMyRewards = () => {
    updateRewardsView({...rewardsViewData, openDisclosure: true, openDisclosureMyRewards: true});
  };

  const handleUpdateReadNotification = async (notificationId, read, type) => {
    markNotificationAsRead(notificationId);
    setHasUpdatedNotifications(true);
    handleGetNotifications();
    if (read === true) {
      await NotificationsService.UpdateNotification(notificationId, { read: read });
    }
    if (type === 'level_up') {
      handleOpenDisclosureMyRewards();
    }
  }

  const handleLoadMoreNotifications = useCallback(async () => {
    if (isLoading) return;
    if (!hasMore) return;
    setIsLoading(true);
    let response = await loadNotificationsByUser(localStorage.getItem('doc'), page, notificationConfigs.initNotificationsRows);
    let notifications = response?.notifications ?? [];
    if (notifications.length > 0) {
      setHasMore(true);
      addNotificationsfromPaginateToLocalStorage(notifications);
      setPage((prevPage) => prevPage + 1);
      setIsLoading(false);
      handleGetNotifications();
    } else {
      setIsLoading(false);
      setHasMore(false);
    }
  }, [page, isLoading]);

  const handleGetNotifications = () => {
    const storedNotifications = getNotificationsFromLocalStorage();
    if (Array.isArray(storedNotifications) && storedNotifications.length > 0) {
      let renderedNotifications = storedNotifications.map(renderNotification);
      handleSetUnreadNotifications(renderedNotifications);
      setNotifications(renderedNotifications);
    }
  }

  useEffect(() => {
    const storedNotifications = getNotificationsFromLocalStorage();
    if (Array.isArray(storedNotifications) && storedNotifications.length > 0) {
      let renderedNotifications = storedNotifications.map(renderNotification);
      handleSetUnreadNotifications(renderedNotifications);
      setNotifications(renderedNotifications);
    }
  }, [hasUpdatedNotifications]);


  return (
    <>
      {
        device === 'desktop' && (
          <>
            <MenuBell
              noti={notifications}
              iconEffect={iconEffect}
              handleUpdateReadNotification={handleUpdateReadNotification}
              handleLoadMoreNotifications={handleLoadMoreNotifications}
              isLoading={isLoading}
              hasMore={hasMore}
            ></MenuBell>
            {
              unreadNotifications &&
              (<div className={`absolute w-3 h-3 bg-red rounded-full right-0 top-2 border border-2 border-purpleLight`}></div>)
            }
          </>
        )
      }
      {
        device !== 'desktop' &&
        (
          <>
            <DisclosureBell
              noti={notifications}
              iconEffect={iconEffect}
              handleUpdateReadNotification={handleUpdateReadNotification}
              handleLoadMoreNotifications={handleLoadMoreNotifications}
              isLoading={isLoading}
              hasMore={hasMore}
            ></DisclosureBell>
            {
              unreadNotifications &&
              (<div className={`absolute w-3 h-3 bg-red rounded-full left-2 top-1 border border-2 border-purpleLight`}></div>)
            }
          </>
        )
      }
    </>
  );
};

